import Call from '../Call';

const Segments = {
    get() {
        return Call('segments');
    },

    getPage(pageNum) {
        return Call(`segments/${pageNum}`);
    },

    save(segment) {
        return Call(`segments`,'POST',segment);
    },

    update(segmentID, segment) {
        return Call(`segments/${segmentID}`,'PUT',segment);
    },

    remove(segmentID) {
        return Call(`segments/${segmentID}`,'DELETE');
    }
}

export default Segments;


// WEBPACK FOOTER //
// ./src/services/API/components/Segments.js